<script>
  import { onMount } from "svelte";
  import Header from "./Header.svelte";
  import { albums } from "./albums";

  export let album;

  const albumInfo = albums.find((a) => a.album === album);

  const images = albumInfo.images || [1, 2, 3, 4];

  let currentImage = 1;

  const selectImage = (image) => {
    currentImage = image;
  };

  onMount(() => {
    const listener = (event) => {
      if (event.keyCode === 39) {
        const idx = images.indexOf(currentImage);
        if (idx < images.length - 1) {
          currentImage = images[idx + 1];
        }
      }
      if (event.keyCode === 37) {
        const idx = images.indexOf(currentImage);
        if (idx > 0) {
          currentImage = images[idx - 1];
        }
      }
    };

    window.addEventListener("keydown", listener);
    return () => {
      window.removeEventListener("keydown", listener);
    };
  });
</script>

<div class="main">
  <Header>
    <div class="header-info">
      <i>{albumInfo.name}</i>, {albumInfo.year},
      {albumInfo.size}
      {#if albumInfo.price === "sold"}
        <span class="sold"> &nbsp&nbsp; unavailable</span>
      {/if}
    </div>
  </Header>

  <div class="main-image">
    <img src="images/{album}/{currentImage}.jpeg" />
  </div>

  <div class="thumbs">
    {#each images as image}
      <img
        class="thumb"
        src="images/{album}/{image}.jpeg"
        on:click={() => selectImage(image)}
      />
    {/each}
  </div>
</div>

<style>
  .main {
    display: flex;
    flex-direction: column;
  }
  .main-image {
    display: flex;
    justify-content: center;
    /* 80px is the height of .thumbs and 55px is the height of .album-info */
    height: calc(var(--app-height) - 80px - 55px);
  }
  .main-image img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
  .thumbs {
    display: flex;
    flex-direction: row;
    gap: 10px;
    justify-content: center;
    align-items: center;
    height: 80px;
  }
  .thumb {
    cursor: pointer;
    width: 80px;
    height: 80px;
    object-fit: contain;
  }
  .sold {
    color: #ec644b;
  }
  .header-info {
    font-size: 1rem;
  }
  @media (max-width: 600px) {
    .header-info {
      font-size: 0.8rem;
    }
  }
</style>
